export enum BooleanTrueValues {
  true = 'true',
  one = '1',
  on = 'on',
  yes = 'yes',
  y = 'y',
  enabled = 'enabled',
  active = 'active',
}
